/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  InputAdornment,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import DashboardFrontCard from "../../../components/Layouts/FleetDistanceInsightsCard/DashboardFrontCard";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import GoogleMapApi from "../../../components/Layouts/GoogleMapIotTracker/Maps";
import IotDisconnected from "./IotDisconnected";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [submittedSearchValue, setSubmittedSearchValue] = useState("");
  const [iotDetailData, setIotDetailData] = useState<any>();
  const [showDisconnected, setShowDisconnected] = useState(false); // toggle for table

  const handleClearSearch = () => setSearchValInput("");

  useEffect(() => {
    const timerId = setTimeout(() => {
      setSubmittedSearchValue(searchValInput);
    }, 500);
    return () => clearTimeout(timerId);
  }, [searchValInput]);

  useEffect(() => {
    ZyppLiteApi.api
      ?.iotDeatailData()
      .then((response) => {
        if (response?.code === 2000) setIotDetailData(response.data);
        else setIotDetailData([]);
      })
      .catch((error) => console.error("API call error: ", error));
  }, []);

  return (
    <div>
      <div className="flex ml-4">
        <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
          IOT Details
        </h2>
      </div>

      <div className="p-10">
        <div className="w-full flex gap-4">
          <DashboardFrontCard
            textFirstLine="Total IoTs Available"
            clientData={iotDetailData?.totalIoTsAvailable}
            imageURL="/assets/blue-iot-icon.svg"
            lineImageURL="/assets/blue-line.svg"
            totalData={0}
          />

          <DashboardFrontCard
            textFirstLine="Total Connected IoTs"
            totalData={0}
            clientData={iotDetailData?.totalConnectedIoTs}
            imageURL="/assets/green-iot-icon.svg"
            lineImageURL="/assets/green-line.svg"
          />

          {/* Disconnected card + toggle below it */}

          <DashboardFrontCard
            textFirstLine="Total Disconnected IoTs"
            totalData={0}
            clientData={iotDetailData?.totalDisconnectedIoTs}
            imageURL="/assets/red-iot-icon.svg"
            lineImageURL="/assets/red-line.svg"
          />
        </div>
        <div className="mt-2 ml-1 flex justify-end">
          <FormControlLabel
            control={
              <Switch
                checked={showDisconnected}
                onChange={(_, checked) => setShowDisconnected(checked)}
                color="success" // ✅ green
              />
            }
            label={
              showDisconnected
                ? "Hide Disconnected Table"
                : "Show Disconnected Table"
            }
          />
        </div>
        {showDisconnected ? (
          <div style={{ width: "100%", minHeight: "23rem", padding: "20px" }}>
            <IotDisconnected />
          </div>
        ) : (
          <div className="flex-grow w-full bg-[#fff] font-rubik relative box-shadow rounded-xl mt-6">
            <div className="flex justify-between items-center border-b pt-3">
              <div>
                <h2 className="text-center mx-1 mt-1 font-bold ml-5 text-base text-[#263238] pb-2">
                  {showDisconnected ? "Disconnected IoTs" : "IOT Location"}
                </h2>
              </div>

              <div className="flex mr-4 mb-4">
                <div className="flex w-full justify-end">
                  <div className="mr-3">
                    <TextField
                      placeholder="Vehicle Number & User Id"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(e: any) => setSearchValInput(e.target.value)}
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: {
                          height: "40px",
                          borderRadius: "25px",
                          width: "300px",
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Toggle area: Map OR IotDisconnected */}

            <div style={{ width: "100%", height: "23rem", padding: "20px" }}>
              <GoogleMapApi searchQrCode={submittedSearchValue} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FleetDailyReport;
